export const api = {
	// domain: 'https://czc.guanmini.com',
	// main: 'https://czc.guanmini.com/admin', //主域名
    domain: 'https://www.guanmini.com',
	main: 'https://www.guanmini.com/api', //主域名
    // domain: 'https://grow.actyper.com',
	// main: 'https://grow.actyper.com/api', //主域名
	login:'/api/Login/index',
    uidLogin:'/api/Login/getUserByToken',
    teacherInfo:'/api/login/get_teacher_info',
    studentList:'/api/student/index',
    createStudent:'/api/student/add',
    editStudent:'/api/student/update',
    delStudent:'/api/student/delete',
    delAlbum:'/api/Album/delete',
    studentAlbum:'/api/student/student_album',
    addPhoto:'/api/Oss/add',
    albumList:'/api/Album/index',
    editAlbum:'/api/album/update',
    createAlbum:'/api/album/add',
    albumPhoto:'/api/AlbumImg/index',
    getClassStudent:'/eldership/Student/getStudentList',
    searchAlbumPhoto:'/api/Distribution/search',
    albumAdd:'/api/AlbumImg/add',
    rmPhoto:'/api/Distribution/rm',
    dis_all:'/api/Distribution/dis_all',
    img_info:'/api/Distribution/img_info',
    dis_img:'/api/Distribution/dis_one',
    delPhoto:'/api/AlbumImg/delete_img',
    addStudentPhoto:'/api/AlbumImg/add_student',
    unbindPhoto:'/api/Distribution/rm',
    personalPhoto:'/api/Personal/index',
    delPersonalPhoto:'/api/Personal/delete',
    uploadPersonal:'/api/Personal/add',
    getFonts:"/api/Fonts/getFonts",
    studentPhoto:'/eldership/AlbumImg/index',
    studentAlbumPhoto:'/api/AlbumImg/index',
    removeBind:'/api/Distribution/rm',
    albumTime:'/api/AlbumImg/album_img_time',
    rmBindStudent:'/api/Distribution/rm',
    disOnes:'/api/Distribution/dis_ones',
    sendMsm:'/api/Login/sendSMS',
    checkCode:'/api/Login/validateMobile',
    changePwd:'/api/Login/changePassword',
    checkPwd:'/api/Login/validatePassword',
    changeMobile:'/api/Login/changeMobile',
    growPage:'/api/Cooperation/grow_page_num',
    parentCooperation:'/api/Parents/cooperation',
    growCooperation:'/api/Cooperation/grow_up_content',
    growupCooperation:'/api/Cooperation/grow_page_num',
    growupCooperation2:'/api/Parents/getGrowUpCooperation',
    growPlateList:'/api/GrowUpContent/index',
    growupDetail:'/api/GrowUpContent/detail',
    getUserInfo:'/api/Login/getUserInfo',
    //编辑器复制
    getBackground:'/admin/Background/getBackground',
    getPaster:'/admin/Paster/getPaster',
    getFrame:'/admin/Frame/getFrame',
    getBuiltUp:'/admin/BuiltUp/getBuiltUp',
    addBuiltUp:'/admin/BuiltUp/edit',
    buildUpDetail:'/admin/BuiltUp/detail',
    getPlateDetail:'/admin/Template/detail',
    addPlateContent:'/admin/TemplateContent/add',
    updatePlateContent:'/admin/TemplateContent/edit',
    getPlateRows:'/admin/TemplateContent/index',
    getPlatePageDetail:'/admin/TemplateContent/detail',
    delPlateContent:'/admin/TemplateContent/delete',
    albumAdd2:'/api/Oss/add',
    searchPlate:'/admin/TemplateContent/getTemplateList',
    copyPlate:'/admin/TemplateContent/copyTemplateContent',
    //
    getBackground2:'/api/GrowUpContent/getBackground',
    getPaster2:'/api/GrowUpContent/getPaster',
    getFrame2:'/api/GrowUpContent/getFrame',
    getBuiltUp2:'/api/GrowUpContent/getBuiltUp',
    getPhoto2:'/api/GrowUpContent/getPhoto',
    batchDel:'/api/GrowUpContent/batchDelElement',
    batchAdd:'/api/GrowUpContent/batchAddElement',
    batchEdit:'/api/GrowUpContent/batchEditElement',
    batchEditBg:'/api/GrowUpContent/batchEditBg',
    batchGetElement:'/api/GrowUpContent/batchGetElement',
    growPages:'/api/GrowUpContent/getContentList',
    //成长册
    submitGrowup:'/api/GrowUp/complete',
    classRecord:'/api/GrowUp/record',
    //消息
    newsList:'/api/Parents/get_message',
    newsCount:'/api/Parents/read_count',
    newsDetail:'/api/Parents/read_message',
    domain2:'https://yjk.dzuo.net/ds',
    uploadBigAvatar:'/schoolphoto/savaSchoolFacePhoto.htm',
    getBigAvatar:'/schoolphoto/getSchoolFacePhoto.htm',
    getGrowupSize:'/api/GrowUpContent/getContentSize',
    resetGrowupPage:'/api/growUpContent/resetPage',
    batchCancel:'/api/GrowUpContent/replayElement',
    resetGrowupPageSid:'/api/GrowUpContent/singleCooperation',
    downloadDrawpage:'/guanmi/drawPageASync.htm',
    getPdfTaskPage:'/guanmi/getPdfTaskPage.htm',
    reloadImg:'/guanmi/syncCDAlbum.htm',
    pasterClass:'/api/PasterClass/getList',
    getPross:'/api/progress/index',
    //文本模板
    getTextClass:'/api/TextManage/getClass',
    addTextClass:'/api/TextManage/addClass',
    editTextClass: '/api/TextManage/editClass',
    delTextClass:'/api/TextManage/deleteClass',
    getTextList:'/api/TextManage/index',
    addTextTel:'/api/TextManage/addText',
    editTextTel:'/api/TextManage/editText',
    delTextTel:'/api/TextManage/deleteText',
    //个人模板
    copyStudentTpl: '/api/SelfTemplate/copyStudentTemplate',
    tplList: '/api/SelfTemplate/index',
    tplPages: '/api/SelfTemplate/templatePages',
    downloadImgs: '/api/albumImg/downloadPhotos'
}
